module.exports = __webpack_public_path__ + "img/a11.9d7fb937.jpg";